import type { SVGProps } from 'react'

export function DoubleNumber(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 16.5V11.1214L10.5607 11.5607C9.97493 12.1465 9.02512 12.1465 8.43934 11.5607C7.85355 10.9749 7.85355 10.0251 8.43934 9.43934L11.4393 6.43935C11.8683 6.01036 12.5135 5.88207 13.074 6.11423C13.6345 6.3464 14 6.89335 14 7.50004V16.5C14 17.3284 13.3284 18 12.5 18C11.6716 18 11 17.3284 11 16.5Z"
        fill="currentColor"
      />
      <path
        d="M28 25.5C28 24.6716 27.3284 24 26.5 24C25.6846 24 25.0211 24.6508 25.0006 25.4613L24.9995 25.5387C24.979 26.3493 24.3155 27 23.5001 27C22.6716 27 22.0001 26.3284 22.0001 25.5C22.0001 23.0147 24.0148 21 26.5 21C28.9853 21 31 23.0147 31 25.5C31 26.9743 30.2894 28.2832 29.1983 29.1015L29.1983 29.1016L28.0003 30H29.5C30.3284 30 31 30.6716 31 31.5C31 32.3284 30.3284 33 29.5 33H23.5001C22.8544 33 22.2812 32.5868 22.0771 31.9743C21.8729 31.3618 22.0836 30.6874 22.6002 30.3L27.3983 26.7015C27.7665 26.4254 28 25.9902 28 25.5Z"
        fill="currentColor"
      />
      <path
        d="M21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5ZM25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5Z"
        fill="currentColor"
      />
      <path
        d="M15.4375 25.8258C16.2854 25.7565 17.0305 26.3768 17.1206 27.2178L17.1244 27.258L17.1344 27.3708C17.5814 32.1382 21.5965 35.8704 26.4817 35.8704C31.6669 35.8704 35.8704 31.6669 35.8704 26.4817C35.8704 21.5965 32.1382 17.5814 27.3708 17.1344L27.258 17.1244L27.2178 17.1206C26.3768 17.0305 25.7565 16.2854 25.8258 15.4375C25.895 14.5896 26.6279 13.955 27.4724 14.0025L27.5127 14.0052L27.6633 14.0185C34.0236 14.6148 39 19.9663 39 26.4817C39 33.3953 33.3953 39 26.4817 39C19.9663 39 14.6148 34.0236 14.0185 27.6633L14.0052 27.5127L14.0025 27.4724C13.955 26.6279 14.5896 25.895 15.4375 25.8258Z"
        fill="currentColor"
      />
    </svg>
  )
}
